<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name"></admin-title>
    <div class="header-search">
      <el-form ref="form" inline :model="searchData">
        <el-form-item label="门店名称">
          <el-input
            v-model="searchData.storeName"
            class="search-input"
            size="small"
            placeholder="请输入门店名称"
            clearable
            @keyup.enter.native="handleSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input
            v-model="searchData.employeeName"
            class="search-input"
            size="small"
            placeholder="请输入姓名"
            clearable
            @keyup.enter.native="handleSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            v-model="searchData.mobile"
            class="search-input"
            size="small"
            placeholder="请输入手机号"
            maxlength="11"
            clearable
            @keyup.enter.native="handleSearch"
          ></el-input>
        </el-form-item>
        <el-form-item label=" ">
          <el-button type="primary" size="small" icon="el-icon-search" @click="handleSearch">查询</el-button>
          <el-button type="info" size="small" icon="el-icon-refresh" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-divider></el-divider>

    <tp-table
      :isNeedSerialNumber="false"
      :tableData="list"
      :columns="columns"
      :totalNum="total"
      :current-page.sync="currentPage"
      :pageSize.sync="pageSize"
    />

    <!-- 设置新密码弹框 -->
    <set-password-dialog
      :visible.sync="dialogVisiblePw"
      :row="currentRow"
      @success="handlePwSuccess"
    />
  </div>
</template>

<script>
import { authBtnMixin } from '@/mixins/authBtnMixin';
import { getListAPI } from './api';
import SetPasswordDialog from './components/SetPasswordDialog.vue';

/**
 * 角色 tag 映射（文案以后端 employeeTypeName 为准，这里只决定 tag 颜色）
 * employeeType：1-法人 2-员工
 */
const ROLE_MAP = {
  staff: { tagType: 'warning' },
  legal: { tagType: '' }
};
const ROLE_CODE_MAP = { 1: 'legal', 2: 'staff' };

function getRoleTagType(employeeType) {
  const key = ROLE_CODE_MAP[employeeType];
  return key ? ROLE_MAP[key].tagType : 'info';
}

const columns = [
  {
    label: '门店ID',
    prop: 'storeId',
    minWidth: '90',
    customRender(h, row) {
      return <p>{row['storeId'] || '-'}</p>;
    }
  },
  {
    label: '门店名称',
    prop: 'storeName',
    minWidth: '160',
    customRender(h, row) {
      return <p>{row['storeName'] || '-'}</p>;
    }
  },
  {
    label: '角色',
    prop: 'employeeType',
    minWidth: '90',
    customRender(h, row) {
      return (
        <el-tag size="mini" type={getRoleTagType(row['employeeType'])} effect="light">
          {row['employeeTypeName'] || '-'}
        </el-tag>
      );
    }
  },
  {
    label: '姓名',
    prop: 'employeeName',
    minWidth: '110',
    customRender(h, row) {
      return <p>{row['employeeName'] || '-'}</p>;
    }
  },
  {
    label: '手机号',
    prop: 'mobile',
    minWidth: '130',
    customRender(h, row) {
      return <p>{row['mobile'] || '-'}</p>;
    }
  },
  {
    label: '密码状态',
    prop: 'hasPassword',
    minWidth: '110',
    customRender(h, row) {
      const isSet = !!row['hasPassword'];
      const color = isSet ? '#52c41a' : '#909399';
      const dotColor = isSet ? '#52c41a' : '#c0c4cc';
      return (
        <span style={`color:${color}`}>
          <i
            style={`display:inline-block;width:6px;height:6px;border-radius:50%;background:${dotColor};margin-right:6px;vertical-align:middle;`}
          ></i>
          {isSet ? '正常' : '未设置'}
        </span>
      );
    }
  },
  {
    label: '状态',
    prop: 'status',
    minWidth: '90',
    customRender(h, row) {
      const isEnable = !!row['status'];
      return (
        <el-tag size="mini" type={isEnable ? 'success' : 'info'} effect="light">
          {isEnable ? '启用' : '禁用'}
        </el-tag>
      );
    }
  },
  {
    label: '操作',
    minWidth: '110',
    fixed: 'right',
    customRender(h, row) {
      return (
        <el-link
          disabled={!this.isShowBtn(this.AUTH_BTN.store_admin_reset_pw)}
          underline={false}
          type="primary"
          onClick={() => this.handleSetPassword(row)}
        >
          设置新密码
        </el-link>
      );
    }
  }
];

export default {
  name: 'StoreAdminList',
  components: { SetPasswordDialog },
  mixins: [authBtnMixin],
  data() {
    return {
      columns,
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchData: {
        storeName: '',
        employeeName: '',
        mobile: ''
      },
      dialogVisiblePw: false,
      currentRow: {}
    };
  },
  provide() {
    return {
      context: this
    };
  },
  watch: {
    currentPage() {
      this.getList();
    },
    pageSize() {
      this.currentPage = 1;
      this.getList();
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      const { storeName, employeeName, mobile } = this.searchData;
      const params = {
        storeName: storeName.trim(),
        employeeName: employeeName.trim(),
        mobile: mobile.trim(),
        page: this.currentPage,
        pageSize: this.pageSize
      };
      const res = await getListAPI(params);
      this.list = res.list || [];
      this.total = res.total || 0;
    },
    // 查询：回到第一页（页码变化会触发 watch 重新拉取）
    handleSearch() {
      if (this.currentPage !== 1) {
        this.currentPage = 1;
      } else {
        this.getList();
      }
    },
    reset() {
      Object.assign(this.searchData, this.$options.data().searchData);
      this.handleSearch();
    },
    // 打开设置新密码弹窗
    handleSetPassword(row) {
      this.currentRow = { ...row };
      this.dialogVisiblePw = true;
    },
    // 密码设置成功后刷新列表
    handlePwSuccess() {
      this.getList();
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  .header-search {
    .search-input {
      width: 200px;
    }
  }
}

// 响应式：小屏适配
@media screen and (max-width: 768px) {
  .wrapper {
    .header-search {
      ::v-deep .el-form-item {
        display: block;
        margin-right: 0;
      }

      .search-input {
        width: 100%;
      }
    }
  }
}
</style>
